import { render, staticRenderFns } from "./CatalogFilter.vue?vue&type=template&id=d71b3080&"
import script from "./CatalogFilter.vue?vue&type=script&lang=js&"
export * from "./CatalogFilter.vue?vue&type=script&lang=js&"
import style0 from "./CatalogFilter.vue?vue&type=style&index=0&id=d71b3080&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports